import { get } from './http'

const AUTHORIZE = {
    // 获取任务列表
    heartBeat: () => {
      return get('/authorize/frontend/heartbeat')
    }
}


export default AUTHORIZE